import { UserFields } from 'main/gql/user'
import { postalCodeInputIsValid } from 'main/util/address'
import { phoneInputIsValid } from 'main/util/phone'
import { IParams, IValidation } from './types'

export function initialParams(user: UserFields) {
  return {
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    phone: user.phone || '',
    postalCode: user.address && user.address.postalCode ? user.address.postalCode : '',
  }
}

export function validate(params: IParams): IValidation {
  const { firstName, phone, postalCode } = params
  const validation: IValidation = {}

  if (!firstName.trim()) validation.firstName = 'Please enter a first name'

  if (phone && !phoneInputIsValid(phone)) {
    validation.phone = 'Please enter a valid phone number'
  }

  if (postalCode && !postalCodeInputIsValid(postalCode)) {
    validation.postalCode = 'Please enter a valid zip code'
  }

  return validation
}

export function isFormRequired(user: UserFields) {
  const address = user.address
  const hasPostalCode = !!(address && address.postalCode)

  return !user.firstName || !user.lastName || !user.phone || !hasPostalCode
}
